<template>
  <v-row>
    <v-col class="text-center mb-4" cols="12" >
      <h4 class="kbGrayText--text">
        {{ $t('general.verifyInfoBeforeListCreation') }}
      </h4>
    </v-col>

    <v-col cols="12">
      <v-data-table
        class="elevation-4 mx-4 mb-2"
        :headers="importerHeaders"
        :items="importerPersons"
        :footer-props="{
          'items-per-page-options': [50, 100, 200]
        }"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td
              v-for="(td, index) in importerHeaders"
              :key="td + index">
              {{ item[importerHeaders[index].text] }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    importerHeaders: {
      type: Array,
      required: true
    },
    importerPersons: {
      type: Array,
      required: true
    }
  }
}
</script>
